import * as React from 'react'
import { connect } from 'react-redux'

import * as Yup from 'yup'
import { Form, Formik, FormikProps } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input, Label, Modal, Button, FormGroup, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import { ClaimInvoice } from 'src/lib/interfaces/ClaimInvoice.interface'

import * as invoicesActions from '../../../store/invoices/actions'

const moment = require('moment')

interface FormValues {
  datePaid?: string
  checkNumber?: string
}

interface InvoicePaymentModalProps {
  open?: boolean
  onClose: () => void
  invoiceId: string|number
  payInvoice: (invoiceId: number|string, datePaid: string, checkNumber: string, next?: (err?: any, invoice?: ClaimInvoice) => void) => void
}

interface InvoicePaymentModalState {
  isLoading: boolean
}

class InvoicePaymentModal extends React.Component<InvoicePaymentModalProps> {
  state = {
    isLoading: false
  }

  get validationSchema() {
    return Yup.object().shape({
      datePaid: Yup.string().required(),
      checkNumber: Yup.string().required()
    })
  }

  handleSubmit(values) {
    const { invoiceId, payInvoice } = this.props

    this.setState({ isLoading: true }, () => {
      payInvoice(invoiceId, values.datePaid, values.checkNumber, (err?: any, invoice?: ClaimInvoice) => {
        if (!err) {
          this.setState({ isLoading: false }, this.props.onClose)
        }
      })
    })
  }

  render() {
    const { isLoading } = this.state
    const { open, onClose } = this.props

    return (
      <Modal isOpen={open} toggle={onClose}>
        <Formik
          initialValues={{}}
          validationSchema={this.validationSchema}
          onSubmit={values => this.handleSubmit(values)}
          render={(props: FormikProps<FormValues>) => (
            <Form>
              <ModalHeader toggle={onClose}>Pay Invoice</ModalHeader>
              <ModalBody>
                  <FormGroup>
                    <Label className="font-weight-bold text-secondary">Check Number</Label>
                    <Input
                      name="checkNumber"
                      onChange={props.handleChange}
                      value={props.values.checkNumber}
                    />
                  </FormGroup>

                  <FormGroup className="mt-3">
                    <Label className="font-weight-bold text-secondary">Check Date</Label>
                    <Input
                      type="date"
                      name="datePaid"
                      value={props.values.datePaid}
                      onChange={props.handleChange}
                    />
                  </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="light" onClick={onClose} disabled={isLoading}>Cancel</Button>
                <Button type="submit" color="primary" disabled={isLoading || !props.isValid}>
                  {isLoading &&
                    <FontAwesomeIcon spin className="mr-2" icon={['fas', 'spinner']} />
                  }
                  Pay
                </Button>
              </ModalFooter>
            </Form>
          )}
        />
      </Modal>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  payInvoice: (invoiceId: number|string, datePaid: string, checkNumber: string, next?: (err?: any, invoice?: ClaimInvoice) => void) =>
    dispatch(invoicesActions.payInvoice(invoiceId, datePaid, checkNumber, next))
})

export default connect(null, mapDispatchToProps)(InvoicePaymentModal)



// WEBPACK FOOTER //
// ./src/routes/invoices/components/InvoicePayment.modal.tsx